import React from 'react';
import { useUpdateEffect } from 'react-use';
import { useSelector } from 'react-redux';
import * as profileSelectors from '@src/containers/ProfileVenue/selectors';
import ProfileAlbumsComponent from '..';

const ProfileAlbumsConnector = () => {
	const profileAlbums = useSelector(profileSelectors.profileAlbumsMapped);
	const [isMore, setIsMore] = React.useState(profileAlbums.length > 7);
	const handleShowMore = React.useCallback(() => {
		setIsMore(false);
	}, []);

	useUpdateEffect(() => {
		setIsMore(profileAlbums.length > 7);
	}, [profileAlbums.length]);

	const slicedAlbums = React.useMemo(() => {
		if (isMore) {
			return profileAlbums.slice(0, 7);
		}
		return profileAlbums;
	}, [isMore, profileAlbums]);

	return (
		<ProfileAlbumsComponent
			items={slicedAlbums}
			isShowMore={isMore}
			onShowMoreClick={handleShowMore}
		/>
	);
};

export default ProfileAlbumsConnector;
